"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbSelectGeneral = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _value = require("../../skybase-core/utils/value");

var _reactIntl = require("react-intl");

var _isTriggeredInside = require("../../skybase-core/utils/is-triggered-inside");

var _index = require("./index");

var _utils = require("./utils");

var _constants = require("./constants");

var _shapes = require("./shapes");

var _sbGeneralI18n = require("./sb-general-i18n");

var _sbSelectLivesearch = require("./sb-select-livesearch");

var _constants2 = require("../sb-dropdown/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MULTISELECT = _constants.COMPONENT_TYPE.MULTISELECT,
    DROPDOWN = _constants.COMPONENT_TYPE.DROPDOWN;

var _SbSelectGeneral = /*#__PURE__*/function (_Component) {
  _inherits(_SbSelectGeneral, _Component);

  var _super = _createSuper(_SbSelectGeneral);

  function _SbSelectGeneral(props) {
    var _props$items;

    var _this;

    _classCallCheck(this, _SbSelectGeneral);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleOnOptionClick", function (_ref) {
      var value = _ref.value;
      var _this$props = _this.props,
          mode = _this$props.mode,
          onChange = _this$props.onChange,
          selected = _this$props.selected;

      if (onChange) {
        if (mode === _constants.MODE.RADIO) {
          onChange(value);
        } else {
          onChange((0, _utils.detectSelected)({
            selected: selected,
            value: value,
            order: _this.order
          }));
        }
      }

      if (_this.liveSearch && _this.liveSearch.focus) {
        _this.liveSearch.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMultipleOptionClick", function (_ref2) {
      var options = _ref2.options,
          newValue = _ref2.newValue;
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          selected = _this$props2.selected;

      if (onChange) {
        onChange((0, _utils.detectSelected)({
          selected: selected,
          value: options,
          order: _this.order,
          newValue: newValue
        }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLiveSearch", function (value) {
      var disabled = _this.props.disabled;

      if (!disabled) {
        _this.setState({
          searchValue: value.toLowerCase()
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSetLiveSearch", function (node) {
      _this.liveSearch = node;
    });

    _defineProperty(_assertThisInitialized(_this), "handleResetLiveSearchValue", function () {
      _this.setState({
        searchValue: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnFocus", function () {
      var isFocused = _this.state.isFocused;
      var onFocus = _this.props.onFocus;

      if (!isFocused) {
        _this.setState({
          isFocused: true
        }, onFocus());
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBlur", function () {
      var isFocused = _this.state.isFocused;
      var onBlur = _this.props.onBlur;

      if (isFocused) {
        _this.setState({
          isFocused: false
        }, onBlur());
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      if (event && (0, _isTriggeredInside.isTriggeredInside)(_this.node, event) || // triggered inside menu
      event.target && typeof event.target.className === 'string' && event.target.className.indexOf(_constants2.AUTOCOMPLETE_ICON_CLOSE) !== -1 // triggered by X button
      ) {
          _this.handleOnFocus();

          return;
        }

      _this.handleOnBlur();
    });

    _defineProperty(_assertThisInitialized(_this), "renderNoOption", function () {
      var _ = _this.props.intl.formatMessage;
      return _this.renderOneOption({
        option: {
          label: _(_sbGeneralI18n.messages.noOptions),
          disabled: true,
          value: 'no_value'
        },
        forcedMode: _constants.MODE.RADIO
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderOptions", function () {
      var _this$props3 = _this.props,
          children = _this$props3.children,
          items = _this$props3.items,
          id = _this$props3.id,
          defaultMode = _this$props3.mode,
          selected = _this$props3.selected,
          liveSearch = _this$props3.liveSearch,
          minimumSearchLetters = _this$props3.minimumSearchLetters,
          customBody = _this$props3.customBody;
      var searchValue = _this.state.searchValue;

      if (customBody) {
        return children;
      }

      var tempItems = (!items || !items.length) && children ? (0, _utils.convertComponentsToArray)(_react.default.Children.toArray(children)) : items;
      var formattedOptions = (0, _utils.formatOptions)({
        items: tempItems,
        searchValue: liveSearch && (searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) >= minimumSearchLetters ? searchValue : ''
      });

      if (formattedOptions === null || formattedOptions === void 0 ? void 0 : formattedOptions.length) {
        return formattedOptions.map(function (item, idx) {
          if ((0, _value.isNullOrUndefined)(item.options)) {
            // simple option case
            return _this.renderOneOption({
              option: item,
              key: "".concat(id, "-").concat(idx)
            });
          } // GROUP CASE


          var label = item.label,
              mode = item.mode,
              options = item.options,
              rest = _objectWithoutProperties(item, ["label", "mode", "options"]);

          var groupOptions = options.map(function (option, idx2) {
            return _this.renderOneOption({
              option: option,
              key: "".concat(id, "-").concat(idx2)
            });
          });
          return /*#__PURE__*/_react.default.createElement(_index.SbSelectGroup, _extends({}, rest, {
            key: "".concat(id, "-").concat(idx) // eslint-disable-line react/no-array-index-key
            ,
            label: label,
            mode: defaultMode,
            selected: selected,
            onOptionClick: _this.handleOnOptionClick,
            onMultipleOptionClick: _this.handleOnMultipleOptionClick
          }), groupOptions);
        });
      } // NEITHER ITEMS NOR CHILDREN


      return _this.renderNoOption();
    });

    _defineProperty(_assertThisInitialized(_this), "renderOneOption", function (_ref3) {
      var option = _ref3.option,
          key = _ref3.key,
          forcedMode = _ref3.forcedMode;
      var _this$props4 = _this.props,
          mode = _this$props4.mode,
          selected = _this$props4.selected;

      var value = option.value,
          label = option.label,
          onClick = option.onClick,
          children = option.children,
          componentType = option.componentType,
          rest = _objectWithoutProperties(option, ["value", "label", "onClick", "children", "componentType"]);

      if (componentType === _constants.COMPONENT_TYPE.DIVIDER) {
        return /*#__PURE__*/_react.default.createElement(_index.SbSelectDivider, _extends({
          key: key
        }, rest));
      }

      return /*#__PURE__*/_react.default.createElement(_index.SbSelectOption, _extends({}, rest, {
        key: key // eslint-disable-line react/no-array-index-key
        ,
        value: value,
        label: label,
        mode: forcedMode !== null && forcedMode !== void 0 ? forcedMode : mode,
        onClick: _this.handleOnOptionClick,
        onOptionClick: onClick,
        isSelected: (0, _utils.isOptionSelected)({
          option: option,
          selected: selected
        })
      }), children);
    });

    _defineProperty(_assertThisInitialized(_this), "renderLiveSearch", function () {
      var _this$props5 = _this.props,
          liveSearchPosition = _this$props5.liveSearchPosition,
          hasError = _this$props5.hasError,
          disabled = _this$props5.disabled,
          autoFocusProp = _this$props5.autoFocus,
          id = _this$props5.id,
          opened = _this$props5.opened,
          liveSearch = _this$props5.liveSearch,
          componentType = _this$props5.componentType,
          placeholder = _this$props5.placeholder,
          customBody = _this$props5.customBody;
      var _this$state = _this.state,
          searchValue = _this$state.searchValue,
          isFocused = _this$state.isFocused;

      if (customBody) {
        return null;
      }

      var autoFocus = autoFocusProp;

      if ((0, _value.isNullOrUndefined)(autoFocusProp)) {
        autoFocus = componentType === _constants.COMPONENT_TYPE.DROPDOWN;
      }

      if (!liveSearch) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_sbSelectLivesearch.SbSelectLivesearch, {
        onChange: _this.handleLiveSearch,
        opened: opened,
        value: searchValue,
        id: "".concat(id, "-remove-search-icon"),
        resetLiveSearch: _this.handleResetLiveSearchValue,
        inputRef: _this.handleSetLiveSearch,
        position: liveSearchPosition,
        hasError: hasError,
        disabled: disabled,
        autoFocus: autoFocus,
        isFocused: isFocused,
        onFocus: _this.handleOnFocus,
        placeholder: placeholder
      });
    });

    var defaultSearchValue = props.defaultSearchValue,
        keepOrder = props.keepOrder,
        _customBody = props.customBody;
    _this.state = {
      searchValue: defaultSearchValue !== null && defaultSearchValue !== void 0 ? defaultSearchValue : '',
      defaultSearchValue: defaultSearchValue,
      isFocused: false
    };
    _this.order = !_customBody && keepOrder && (0, _utils.detectOrderOfComponents)(((_props$items = props.items) === null || _props$items === void 0 ? void 0 : _props$items.length) ? props.items : props.children);
    _this.liveSearch = null;
    _this.node = null;
    return _this;
  }

  _createClass(_SbSelectGeneral, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props6 = this.props,
          className = _this$props6.className,
          disabled = _this$props6.disabled,
          menuPositionClass = _this$props6.menuPositionClass,
          hasError = _this$props6.hasError,
          style = _this$props6.style,
          maxHeight = _this$props6.maxHeight,
          height = _this$props6.height,
          minHeight = _this$props6.minHeight,
          liveSearch = _this$props6.liveSearch,
          mode = _this$props6.mode,
          id = _this$props6.id;
      var isFocused = this.state.isFocused;
      var mainClass = (0, _classnames.default)({
        disabled: disabled
      }, className);
      var menuClass = (0, _classnames.default)('menu', {
        'is-focused': isFocused,
        'has-error': hasError
      }, menuPositionClass);
      var heightStyle = (0, _utils.getMenuHeightStyle)({
        maxHeight: maxHeight,
        liveSearch: liveSearch,
        minHeight: minHeight,
        height: height
      });
      var menuVerticalPosition = (0, _utils.getVerticalPosition)(menuPositionClass);
      return /*#__PURE__*/_react.default.createElement("div", {
        id: id,
        className: mainClass,
        style: style,
        ref: function ref(node) {
          _this2.node = node;
        },
        role: "listbox",
        "aria-multiselectable": mode === _constants.MODE.CHECKBOX
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: menuClass
      }, menuVerticalPosition === _constants2.menuPositions.BOTTOM && this.renderLiveSearch(), /*#__PURE__*/_react.default.createElement("div", {
        style: heightStyle
      }, this.renderOptions()), menuVerticalPosition === _constants2.menuPositions.TOP && this.renderLiveSearch()));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var defaultProp = nextProps.defaultSearchValue;
      var searchValue = prevState.searchValue,
          defaultState = prevState.defaultSearchValue;

      if (defaultProp !== defaultState) {
        // prop has changed
        return {
          searchValue: searchValue,
          defaultSearchValue: defaultProp
        };
      }

      return {
        searchValue: searchValue
      };
    }
  }]);

  return _SbSelectGeneral;
}(_react.Component);

_defineProperty(_SbSelectGeneral, "propTypes", {
  componentType: _propTypes.default.oneOf([MULTISELECT, DROPDOWN]).isRequired,
  onChange: _propTypes.default.func.isRequired,
  id: _propTypes.default.string.isRequired,
  liveSearch: _propTypes.default.bool.isRequired,
  mode: _shapes.modeShape.isRequired,
  defaultSearchValue: _propTypes.default.string,
  menuPositionClass: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.object),
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  selected: _shapes.selectedShape,
  opened: _propTypes.default.bool,
  minimumSearchLetters: _shapes.NUMBER_OR_STRING,
  style: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  maxHeight: _shapes.NUMBER_OR_STRING,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  keepOrder: _propTypes.default.bool,
  customBody: _propTypes.default.bool
});

_defineProperty(_SbSelectGeneral, "defaultProps", {
  items: null,
  children: null,
  menuPositionClass: null,
  selected: null,
  defaultSearchValue: '',
  opened: true,
  minimumSearchLetters: 2,
  style: null,
  maxHeight: null,
  placeholder: null,
  onFocus: _constants.NOOP,
  onBlur: _constants.NOOP,
  keepOrder: false,
  customBody: false
});

var SbSelectGeneral = (0, _reactIntl.injectIntl)(_SbSelectGeneral);
exports.SbSelectGeneral = SbSelectGeneral;
//# sourceMappingURL=sb-select-general.js.map